import { defineComponent as _defineComponent } from 'vue'
import { router } from '@inertiajs/vue2';
import BaseButton from '@/components/base/BaseButton.vue';
import IconLogo from '@/components/icons/IconLogo.vue';
import route from 'ziggy-js';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailVerifyView',
  props: {
    user: null
  },
  setup(__props: any) {



function handleAlreadyVerified() {
    router.visit(route('organization.create'));
}

function resendVerificationCode() {
    router.post(route('verification.resend'));
}

return { __sfc: true,handleAlreadyVerified, resendVerificationCode, BaseButton, IconLogo }
}

})